import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import { EVENTS } from "../../mock/mock";
import { fetchPublic } from "../adminApi";
import ShareButtons from "../ShareButtons";
import { Reveal, SplitWords } from "../motionHelpers";

export default function EventsTeaser() {
  const [events, setEvents] = useState(EVENTS);
  useEffect(() => {
    fetchPublic("events").then((d) => { if (d && d.length) setEvents(d); }).catch(() => {});
  }, []);
  return (
    <section id="events" className="d2-bg py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <div>
            <span className="font-grotesk uppercase tracking-[0.3em] text-sc-lime text-sm">Get in the Game</span>
            <h2 className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9] mt-3">
              <SplitWords text="Events & Tournaments" />
            </h2>
          </div>
          <Link to="/events" className="d2-btn-ghost inline-flex items-center gap-2 px-6 py-3 text-sm w-fit">View All <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {events.map((e, i) => (
            <Reveal key={e.title} delay={i * 0.08}>
              <div data-hover className="group d2-card flex flex-col bg-[#0b241a] border border-white/10 rounded-2xl overflow-hidden h-full">
                <Link to="/events" className="block">
                  <div className="relative h-52 overflow-hidden">
                    <img src={e.image} alt={e.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                    <span className="absolute top-3 left-3 bg-sc-lime text-sc-green font-grotesk font-bold uppercase text-[11px] tracking-widest px-3 py-1">{e.tag}</span>
                  </div>
                  <div className="p-5 pb-3">
                    <p className="font-mono2 text-xs text-sc-lime uppercase tracking-widest flex items-center gap-2"><CalendarDays className="w-3.5 h-3.5" />{e.date}</p>
                    <h3 className="font-display uppercase text-2xl text-white mt-2 leading-tight">{e.title}</h3>
                    <p className="text-white/50 text-sm mt-1 font-grotesk">{e.level}</p>
                  </div>
                </Link>
                <div className="px-5 pb-5 mt-auto">
                  <ShareButtons event={e} size="sm" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
